import { jwtDecode } from "jwt-decode";
import { logOutAccount } from "store/user";

const isTokenExpired = (token) => {
  if (!token) {
    console.warn("Token is missing");
    return true;
  }

  try {
    const decoded = jwtDecode(token);
    const now = Math.floor(Date.now() / 1000);

    return decoded.exp < now;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true;
  }
};

export const startTokenValidation = (token, dispatch, loginWithRedirect) => {
  if (!token || !dispatch || !loginWithRedirect) {
    console.warn("Missing required parameters for startTokenValidation");
    return;
  }

  if (isTokenExpired(token)) {
    dispatch(logOutAccount());
    loginWithRedirect();
    return;
  }


  const intervalId = setInterval(() => {
    if (isTokenExpired(token)) {
      clearInterval(intervalId);
      dispatch(logOutAccount());
      loginWithRedirect();
    }
  }, 60000);


  return () => clearInterval(intervalId);
};

export const setupTokenValidationOnUserActivity = (
  token,
  dispatch,
  loginWithRedirect
) => {
  if (!token || !dispatch || !loginWithRedirect) {
    console.warn("Missing required parameters for setupTokenValidationOnUserActivity");
    return;
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      if (isTokenExpired(token)) {
        dispatch(logOutAccount());
        loginWithRedirect();
      }
    }
  };


  document.addEventListener("visibilitychange", handleVisibilityChange);


  window.addEventListener("focus", () => {
    if (isTokenExpired(token)) {
      dispatch(logOutAccount());
      loginWithRedirect();
    }
  });


  return () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    window.removeEventListener("focus", () => {});
  };
};

export const setupComprehensiveTokenValidation = (
  token,
  dispatch,
  loginWithRedirect
) => {
  if (!token || !dispatch || !loginWithRedirect) {
    console.warn("Missing required parameters for setupComprehensiveTokenValidation");
    return;
  }


  const clearInterval = startTokenValidation(token, dispatch, loginWithRedirect);


  const cleanupListeners = setupTokenValidationOnUserActivity(
    token,
    dispatch,
    loginWithRedirect
  );


  return () => {
    clearInterval();
    cleanupListeners();
  };
};
